import React from "react";
import { NavLink } from "react-router-dom";
import "../../assets/css/AboutApexo.css";
import aboutImg from "../../assets/images/about.webp";

function AboutApexo() {
  return (
    <section className="about-apexo" id="About">
      <div className="container">

        <div className="row align-items-center">

          {/* ===== TEXT LEFT ===== */}
          <div className="col-lg-6 col-md-12">
            <div className="about-content">

              <span className="section-tag">ABOUT COMPANY</span>

              <h2>
                About <span>Apexo Industrial Pvt. Ltd.</span>
              </h2>

              <p className="subtitle">
                Your trusted industrial trading partner delivering
                high-performance solutions for sugar, distillery,
                co-generation and process industries.
              </p>

              <ul className="about-list">
                <li>35+ Years Industry Experience</li>
                <li>Premium Quality & Certified Products</li>
                <li>Reliable Service & Fast Delivery</li>
                <li>Serving Sugar, Ethanol & Process Industries</li>
              </ul>

              <NavLink to="/aboutapexoindustrial" className="btn-read">
                Explore More →
              </NavLink>

            </div>
          </div>

          {/* ===== IMAGE RIGHT ===== */}
          <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div className="about-image">
              <img src={aboutImg} alt="About Apexo Industrial" />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default AboutApexo;